// Skills Data - Centralized

export const skillGroups = [
  {
    name: "Front-End",
    skills: [
      "HTML5", "CSS3", "JavaScript (ES6+)", "TypeScript", "React.js",
      "Next.js", "Redux Toolkit", "Tailwind CSS", "Bootstrap", "Responsive Web Design",
    ],
  },
  {
    name: "Back-End",
    skills: [
      "Node.js", "Express.js", "Django", "REST APIs", "Socket.IO",
      "WebSockets", "API Integration", "Webhook Development",
    ],
  },
  {
    name: "Databases & Search",
    skills: [
      "MongoDB", "Mongoose", "PostgreSQL", "MySQL", "ChromaDB",
      "Pinecone", "Vector Search",
    ],
  },
  {
    name: "Cloud & DevOps",
    skills: [
      "AWS S3", "AWS EC2", "AWS Amplify", "Nginx", "Docker",
      "Git", "GitHub", "Render", "Deployment & CI/CD Fundamentals",
    ],
  },
  {
    name: "Authentication & Payments",
    skills: [
      "JWT", "Passport.js", "Stripe", "Razorpay",
      "Subscription Billing", "Payment Webhooks", "Role-Based Authorization",
    ],
  },
  {
    name: "AI & Data",
    skills: [
      "Machine Learning", "OpenAI API", "TensorFlow", "Scikit-learn",
      "NumPy", "Pandas", "Matplotlib", "Retrieval-Augmented Generation",
      "Vector Databases", "Jupyter Notebook", "Google Colab",
    ],
  },
  {
    name: "Tools & Platforms",
    skills: [
      "Postman", "LogRocket", "Firebase", "ShipRocket", "Mapbox GL", "Jitsi Meet",
    ],
  },
  {
    name: "Mobile Development",
    skills: ["React Native CLI", "Expo"],
  },
];
